































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
@Component
export default class storeinfomanagecreateoredit extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: Number, default: undefined }) agentId: number;
    @Prop() id: number;
    model: proxy.AgentBalanceAdjustOrderDto = new proxy.AgentBalanceAdjustOrderDto();
    fxArr: any[] = [];
    get areaProx() {
        return new proxy.AreaServiceProxy();
    }
    save() {
        new proxy.AgentBalanceAdjustOrderServiceProxy().createOrUpdate(this.model).then(() => {
            (this.$refs.roleForm as any).resetFields();
            this.$Notice.success({ title: "保存成功" });
            this.$emit("save-success");
            this.$emit("input", false);
        });
    }
    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            new proxy.AgentBalanceAdjustOrderServiceProxy().queryModel(this.id).then((x) => {
                this.model = x;
                this.model.agentId = this.agentId;
            });

            let req = new proxy.AgentPageInputDto();
            req.status = 0;
            req.maxResultCount = 50;
            new proxy.AgentServiceProxy().queryModelList(req).then((x) => {
                this.fxArr = x.items;
            });
        }
    }
    roleRule = {};
}
